module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.56c4c6a8.svg";